import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavLink from '../components/common/NavLink';
import * as urls from '../actions/urlTypes';
import { isFeaturePresent } from '../util/CommonUtils';
import {
  INSIGHT_360_LABEL,
  SALES_CATALYST,
  SALES_CATALYST_FEATUREID,
} from '../constants';

const CatalystNav = ({ children, modulePermissions }) => {
  let renderSalesCatalyst = false;
  if (modulePermissions.length > 0) {
    renderSalesCatalyst = isFeaturePresent(SALES_CATALYST_FEATUREID, modulePermissions);
  }

  return (
    <nav className="nav-dropdown-menu--items">
      <ul className="nav-dropdown-menu--list">
        {(
          <li>
            <NavLink to={`${urls.APP_ROOT_URL}/catalyst/brandcatalyst`}>
              {INSIGHT_360_LABEL}
            </NavLink>
          </li>
        )}
        {(
          <li>
            <NavLink to={`${urls.APP_ROOT_URL}/catalyst/salescatalyst`}>
              {SALES_CATALYST}
              {/* {(renderSalesCatalyst) && <sup>Beta</sup>} */}
            </NavLink>
          </li>
        )}
      </ul>
      {children}
    </nav>
  );
};

CatalystNav.propTypes = {
  children: PropTypes.node,
  modulePermissions: PropTypes.instanceOf(Array),
};

function mapStateToProps(state) {
  return {
    modulePermissions: state.userDetail.permissions,
  };
}

export default connect(
  mapStateToProps,
  null,
)(CatalystNav);
